import { type FieldSuggestion } from '@frontend/api';
import {
  DatePickerProps,
  AssistanceAvailableBackground,
} from '@frontend/components';
import {
  CalendarIcon,
  AssistanceAvailableIcon,
  AssistanceApprovedIcon,
  AssistanceRejectedIcon,
} from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

export type SuffixIconContentProps = {
  suggestion?: FieldSuggestion;
  suggestionIsAccepted?: boolean;
  suggestionIsRejected?: boolean;
  size: DatePickerProps['size'];
};

export const SuffixIconContent = ({
  suggestion,
  suggestionIsRejected,
  suggestionIsAccepted,
}: SuffixIconContentProps) => {
  const suggestionIcon = suggestionIsRejected ? (
    <AssistanceRejectedIcon
      zIndex={1}
      boxSize={2.25}
      color="feature.secondary"
    />
  ) : suggestionIsAccepted ? (
    <AssistanceApprovedIcon
      zIndex={1}
      color="interaction.suggestion"
      boxSize={2.25}
    />
  ) : (
    <AssistanceAvailableIcon
      zIndex={1}
      color="interaction.suggestion"
      boxSize={2.25}
    />
  );

  return (
    <>
      {suggestion && suggestionIcon}
      <CalendarIcon
        zIndex={1}
        color={
          suggestion && !suggestionIsRejected && !suggestionIsAccepted
            ? 'interaction.suggestion'
            : 'feature.secondary'
        }
        boxSize={2.25}
      />
      {suggestion && !suggestionIsRejected && !suggestionIsAccepted && (
        <AssistanceAvailableBackground boxSize={15} />
      )}
    </>
  );
};
